import { useTheme } from '@cbhq/cds-web/hooks/useTheme';

/* logout icon introduced in @cbhq/cds-icons v 2.8.0 https://cds.cbhq.net/changelog/icons/
 * <LogoutIcon /> can be replaced with
 * <Icon size="m" name="logout" color="foreground" />
 * if the icon is available in the version of @cbhq/cds-icons used in the project
 */
export function LogoutIcon() {
  const { activeColorScheme: spectrum } = useTheme();
  const fill = spectrum === 'light' ? '#CF202F' : '#F0616D';
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3009 7.71501L14.6991 6.285L19.4143 10.8954L14.7148 15.6993L13.2852 14.3007L15.5359 12H5V10H15.6378L13.3009 7.71501Z"
        fill={fill}
      />
      <path d="M11 22V16H9V20H2V2H9V6H11V0H-1.90735e-06V22H11Z" fill={fill} />
    </svg>
  );
}
